module.exports = __webpack_public_path__ + "static/4-11cdb6ff9d87b7179aa7bd815215ffd7.svg";